/**
 * Polska liczebność: 1 dział, 2–4 działy, 5–21 działów, 22–24 działy, 12–14 działów.
 * Reguła „2–4 poza 12–14” siedzi w JEDNYM miejscu — używają jej diagram
 * struktury, karty panelu głównego i feed zdarzeń.
 */
export function odmien(n: number, jeden: string, kilka: string, wiele: string): string {
  if (n === 1) return jeden;
  const dziesiatki = n % 100;
  const jednosci = n % 10;
  if (jednosci >= 2 && jednosci <= 4 && !(dziesiatki >= 12 && dziesiatki <= 14)) return kilka;
  return wiele;
}

/** „3 czujniki”, „12 stanowisk” — liczba i odmieniony rzeczownik razem. */
export function zLiczba(n: number, jeden: string, kilka: string, wiele: string): string {
  return `${n} ${odmien(n, jeden, kilka, wiele)}`;
}
